<template>
  <div class="formLogin">
    <a-form-model :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
      <a-form-model-item prop="username">
        <a-input size="large" v-model="ruleForm.username" placeholder="请输入域账号" />
      </a-form-model-item>
      <a-form-model-item prop="password">
        <a-input
          size="large"
          v-model="ruleForm.password"
          type="password"
          placeholder="请输入密码"
        />
      </a-form-model-item>
      <Environment />
    </a-form-model>
    <Vcode :show="errVcode" @success="successVcode" @close="closeVcode" />
    <a-button class="button" @click="submitForm" :loading="btnLoading">登&nbsp;录</a-button>
  </div>
</template>

<script>
import Vcode from 'vue-puzzle-vcode';

import { message } from 'ant-design-vue';
import { pwdPublicKeyEncode } from '@/utils/RSAUtils';
import api from '@/api';
import { post } from '@/utils/http';
// eslint-disable-next-line import/no-unresolved
import ErrorLogin from '@/utils/errorLogin';
import Environment from '../environment.vue';
import { setToken, rmToken } from '../../login-handler';

// eslint-disable-next-line import/order
// import { pointTools , traceClick} from "@/utils/point";

export default {
  name: 'AccountLogin',
  components: {
    Environment,
    Vcode,
  },
  data() {
    return {
      btnLoading: false,
      ruleForm: {
        username: '',
        password: '',
      },
      rules: {
        username: [{ required: true, message: '请输入域账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      errlg: null,
      errVcode: false,
    };
  },

  mounted() {
    this.errlg = new ErrorLogin();
  },
  methods: {
    successVcode() {
      this.errVcode = false;
      this.errlg.refreshPasWord(1);
    },
    closeVcode() {
      // this.errVcode = false;
    },
    // 登录操作
    submitForm() {
      // traceClick(
      //   {
      //     event_type: "web_click",
      //     content: {
      //       event_id: "auth_login_domain_account_click",
      //       event_name: "登录 - 域账号",
      //     },
      //   },
      //   true
      // );
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          if (!this.errlg.voidCodeLogin(1)) {
            this.errVcode = true;
            return;
          }
          rmToken(); // 清除 token
          this.btnLoading = true;
          // eslint-disable-next-line prefer-const
          let password = await pwdPublicKeyEncode(this.ruleForm.password);
          const params = {
            name: this.ruleForm.username,
            // eslint-disable-next-line object-shorthand
            password: password,
          };
          const loginRes = await post(api.login, params).catch(() => {
            // message.error('登录失败');
            this.errlg.addErrorName();
          });
          this.btnLoading = false;
          if (loginRes && loginRes.token) {
            message.success('登录成功');
            // 获取用户信息需要token 所以先对登录信息进行缓存
            setToken(loginRes);
            this.errlg.refreshPasWord(1);
            this.$emit('getLoginAccount', loginRes);
          }
        }
      });
    },
  },
};
</script>
